<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.path)">
        <v-col cols="12">
          <BaseCard
              title="Sample Order Entry"
              icon="mdi-cart-outline"
              vCardTextClass="pa-2"
          >
            <v-form @submit.prevent="submitForm(currentStatus)" ref="" id="">
              <v-row dense>
                <!-- Main Details Card (Left Side) -->
                <v-col md="3" cols="12">
                  <v-card elevation="0" border rounded="lg" class="pa-2 h-100">
                    <div class="d-flex align-center mb-4">
                      <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                        <v-icon size="20">mdi-information-outline</v-icon>
                      </v-avatar>
                      <div>
                        <div class="text-subtitle-1 font-weight-medium">Main details</div>
                        <div class="text-caption text-medium-emphasis">Provide main information</div>
                      </div>
                    </div>
                    <v-row dense>
                      <v-col cols="12">
                        <v-date-input
                            input-format="dd/mm/yyyy"
                            density="compact"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="sample_order_date.value.value"
                            :error-messages="sample_order_date.errorMessage.value"
                            autocomplete="off"
                            clearable>
                          <template #label>
                            Sample Order Date <span class="text-red-accent-4">*</span>
                          </template>
                        </v-date-input>

                        <v-autocomplete
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            v-model="customer_id.value.value"
                            :items="getCustomerMapList"
                            :item-title="item => `${item?.customer?.company_name}` ?? 'N/A'"
                            item-value="customer_id"
                            :error-messages="customer_id.errorMessage.value"
                            autocomplete="off"
                            @update:model-value="onCustomerChange"
                            clearable
                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
                        >
                          <template #label>
                            Customer Name
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-autocomplete>

                        <v-date-input
                            input-format="dd/mm/yyyy"
                            density="compact"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="shipping_date.value.value"
                            :error-messages="shipping_date.errorMessage.value"
                            autocomplete="off"
                            clearable>
                          <template #label>
                            Delivery Date
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-date-input>

                        <v-autocomplete
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            v-model="delivery_address.value.value"
                            :items="contactsAddressList"
                            :item-title="item => `${item?.address}`"
                            item-value="address"
                            :error-messages="delivery_address.errorMessage.value"
                            :loading="contactAddressLoading"
                            autocomplete="off"
                            clearable
                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
                        >
                          <template #label>
                            Delivery Address
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-autocomplete>

                        <v-text-field
                            label="PO/Ref No"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="po_no.value.value"
                            :error-messages="po_no.errorMessage.value"
                            autocomplete="off"
                            clearable>
                        </v-text-field>

                        <v-date-input
                            input-format="dd/mm/yyyy"
                            density="compact"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="po_date.value.value"
                            :error-messages="po_date.errorMessage.value"
                            autocomplete="off"
                            clearable>
                          <template #label>
                            PO Date
                          </template>
                        </v-date-input>

                        <v-autocomplete
                            label="Sales Person"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            v-model="sales_person_id.value.value"
                            :items="getHrmEmployeeList"
                            :item-title="item => `${item.code}-${item.name}` ?? 'N/A'"
                            item-value="id"
                            :error-messages="sales_person_id.errorMessage.value"
                            autocomplete="off"
                            clearable
                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <!-- Item Info Card (Right Side) -->
                <v-col md="9" cols="12">
                  <v-card elevation="0" border rounded="lg">
                    <div class="d-flex align-center pa-3">
                      <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                        <v-icon size="20">mdi-format-list-bulleted</v-icon>
                      </v-avatar>
                      <div>
                        <div class="text-subtitle-1 font-weight-medium">Order items</div>
                        <div class="text-caption text-medium-emphasis">
                          Search and add products to this order
                        </div>
                      </div>
                    </div>
                    <v-row justify="center">
                      <v-col cols="12" md="9" lg="8">
                        <v-autocomplete
                            label="Search Product Name"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            v-model="product_id.value.value"
                            :items="getProductMapList"
                            :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                            item-value="product_id"
                            :error-messages="product_id.errorMessage.value"
                            @update:model-value="addCart"
                            @keydown.enter="addCart"
                            autocomplete="off"
                            hide-details="auto"
                            clearable
                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
                        >
                        </v-autocomplete>

                        <input v-model="sample_order_master_id.value.value" type="hidden" />
                      </v-col>
                    </v-row>

                    <!-- Cart Table -->
                    <v-row>
                      <v-col cols="12">
                        <v-card elevation="0" class="overflow-x-auto">
                          <v-table
                              density="compact"
                              :loading="loading"
                              fixed-header
                              style="max-height: 600px; overflow-y: scroll"
                          >
                            <thead>
                              <tr>
                                <th class="text-center" style="width: 5%">SL</th>
                                <th class="text-center" style="width: 12%">Code</th>
                                <th class="text-left" style="width: 30%">
                                  Product Name
                                </th>
                                <th class="text-center" style="width: 12%">Unit</th>
                                <th class="text-left" style="width: 15%">
                                  Quantity
                                </th>
                                <th class="text-center" style="width: 15%">
                                  Lot No.
                                </th>
                                <th class="text-left" style="width: 15%">
                                  Desc.
                                </th>
                                <th class="text-right" style="width: 5%">Action</th>
                              </tr>
                            </thead>

                            <tbody v-if="cart.length > 0">
                              <template v-for="(item, index) in cart" :key="index">
                                <tr v-if="cart.length > 0">
                                  <td class="text-center py-1 px-1">{{ index + 1 }}</td>
                                  <td class="text-left py-1 px-1">
                                    {{ item.product_code }}
                                  </td>
                                  <td class="text-left py-1 px-1" style="min-width: 150px">
                                    {{ item.product_name }}
                                  </td>
                                  <td class="text-center py-1 px-1">
                                    {{ item.unit_name }}
                                  </td>
                                  <td class="text-left py-1 px-1">
                                    <v-text-field
                                        :reverse="false"
                                        controlVariant="stacked"
                                        style="width: 80px"
                                        label="" :hideInput="false"
                                        :inset="false"
                                        :min="0"
                                        type="number"
                                        density="compact"
                                        variant="underlined"
                                        bg-color="grey-lighten-4"
                                        v-model="item.qty"
                                        hide-details="auto"
                                        @click.stop
                                        @focus.stop
                                        :error="item.qty < 0"
                                        :error-messages="item.qty < 0 ? 'Quantity must be greater than 0' : ''"
                                    >
                                    </v-text-field>
                                  </td>
                                  <td class="text-left py-1 px-1">
                                    <v-text-field
                                        :reverse="false"
                                        controlVariant="stacked"
                                        style="width: 80px"
                                        label="" :hideInput="false"
                                        :inset="false"
                                        type="text"
                                        hide-details="auto"
                                        density="compact"
                                        variant="underlined"
                                        bg-color="grey-lighten-4"
                                        @click.stop
                                        @focus.stop
                                        v-model="item.lot_no"
                                    >
                                    </v-text-field>
                                  </td>
                                  <td class="text-left py-1 px-1">
                                    <v-text-field
                                        :reverse="false"
                                        controlVariant="stacked"
                                        style="width: 100px"
                                        label=""
                                        :hideInput="false"
                                        :inset="false"
                                        type="text"
                                        density="compact"
                                        hide-details="auto"
                                        variant="underlined"
                                        @click.stop
                                        @focus.stop
                                        bg-color="grey-lighten-4"
                                        v-model="item.description"
                                    >
                                    </v-text-field>
                                  </td>
                                  <td style="white-space: nowrap;" class="text-center py-1 px-1">
                                    <v-btn
                                        icon="mdi-delete-outline"
                                        size="small"
                                        color="error"
                                        variant="text"
                                        @click="removeFromCart(index)"
                                    ></v-btn>
                                  </td>
                                </tr>
                              </template>
                            </tbody>


                            <tfoot v-else>
                              <tr>
                                <td colspan="8" class="text-center py-8">
                                  <v-icon size="32" color="primary" class="mb-2">
                                    mdi-cart-outline
                                  </v-icon>
                                  <div class="text-body-2 text-medium-emphasis">
                                    No item selected
                                  </div>
                                </td>
                              </tr>
                            </tfoot>
                          </v-table>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>

            </v-form>

            <v-divider class="mt-2"></v-divider>
            <v-card-actions>
              <v-row align="start">
                <v-col cols="12" md="9">
                  <div class="d-flex justify-space-between align-center mb-2">
                    <v-label class="text-subtitle-1 font-weight-bold">
                      Description
                    </v-label>
                  </div>
                  <Ckeditor
                      :editor="ClassicEditor"
                      v-model="remarks.value.value"
                      :config="editorConfig"
                  ></Ckeditor>
                </v-col>
                <v-col cols="12" md="3">
                  <div class="d-flex justify-end ga-2">
                    <v-btn
                        color="grey-darken-1"
                        variant="flat"
                        prepend-icon="mdi-content-save-outline"
                        @click="submitForm(0)"
                    >
                      draft
                    </v-btn>
                    <v-btn
                        color="primary"
                        variant="flat"
                        prepend-icon="mdi-send-outline"
                        @click="submitForm(1)"
                    >
                      Post
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-actions>
          </BaseCard>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { getCurrentInstance, ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
import BaseCard from "@/components/utils/baseCard.vue";
import { Ckeditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  components: {
    BaseCard,
    Ckeditor
  },
  data: () => ({
    loading: false,
    contactsAddressList: [],
    contactAddressLoading: false,
    isEntryMode: true,
  }),
  computed: {
    branchId() {
      return this.$store.getters.getAuthUser?.branch_id || null;
    },
    getProductMapList() {
      return (this.$store.getters.getProductMapList || []).filter(
        item => item.branch_id == this.branchId && item.status == 1
      );
    },
    getCustomerMapList() {
      return this.$store.getters.getCustomerMapList || [];
    },
    getHrmEmployeeList() {
      return this.$store.getters.getHrmEmployeeList || [];
    },
  },
  created() {
    this.$store.dispatch("getCustomerMapList");
    this.$store.dispatch("getProductMapList");
    this.$store.dispatch("getHrmEmployeeList", { is_all_branch: true });

  },
  methods: {
    onCustomerChange(value) {
      if (!value) {
        this.delivery_address.value.value = null;
        this.contactsAddressList = [];
        return;
      }

      this.contactAddressLoading = true;
      this.$store.dispatch("getCustomerById", value)
        .then(res => {
          this.sales_person_id.value.value = res.dealing_person_id;
          this.contactsAddressList = res?.contacts || [];
        })
        .finally(() => {
          this.contactAddressLoading = false;
        });
    },
    addCart() {
      if (!this.product_id.value.value) return;

      const selected = this.getProductMapList.find(
        item => item.product_id == this.product_id.value.value
      )?.product;
      if (!selected) return;

      if (this.cart.some(item => item.product_id == this.product_id.value.value)) {
        toast.error("The Item Already added!");
        return;
      }

      this.cart.push({
        product_id: selected.id,
        product_name: selected.name,
        product_code: selected.code,
        qty: 1,
        unit_id: selected.unit_id,
        unit_name: selected.unit?.name || "",
        description: "",
        lot_no: "",
      });
      this.product_id.value.value = null;
    },
    removeFromCart(index) {
      if (confirm("Are You Sure?")) this.cart.splice(index, 1);
    },
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        sample_order_date: yup.date().required().label("Sample Order Date"),
        shipping_date: yup.date().nullable().label("Delivery Date"),
        delivery_address: yup.string().nullable().label("Delivery Address"),
        po_no: yup.string().nullable().label("PO/Ref No"),
        po_date: yup.date().nullable().label("PO Date"),
        customer_id: yup.number().positive().integer().required().label("Customer Name"),
      }),
    });

    const product_id = useField("product_id");
    const sample_order_master_id = useField("sample_order_master_id");
    const sample_order_date = useField("sample_order_date");
    const shipping_date = useField("shipping_date");
    const delivery_address = useField("delivery_address");
    const po_no = useField("po_no");
    const po_date = useField("po_date");
    const customer_id = useField("customer_id");
    const sales_person_id = useField("sales_person_id");
    const remarks = useField("remarks");
    const status = useField("status");
    const cart = ref([]);
    const buttonText = ref("Save");
    const currentStatus = ref(0);
    const store = useStore();
    const router = useRouter();

    const submitForm = statusValue => {
      currentStatus.value = statusValue;
      submit();
    };

    const submit = handleSubmit(values => {
      values.status = currentStatus.value;
      values.cart = cart.value.map(item => ({
        product_id: item.product_id,
        qty: item.qty,
        unit_id: item.unit_id,
        description: item.description,
        lot_no: item.lot_no,
      }));
      values.sample_order_date = formattedDate(sample_order_date.value.value);
      values.shipping_date = formattedDate(shipping_date.value.value);
      values.po_date = formattedDate(po_date.value.value);
      values.delivery_address = delivery_address.value.value;
      values.po_no = po_no.value.value;
      values.remarks = remarks.value.value;

      console.log(values);

      store.dispatch("saveUpdateSampleOrder", values)
        .then(response => {
          resetForm();
          buttonText.value = "Save";
          cart.value = [];
          proxy.cart = [];
          toast.success(response.data.message, { timeout: 3000 });
          setTimeout(() => router.push({ name: "sample-order-record" }), 2000);
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || "Something went wrong");
        });
    });

    return {
      submitForm,
      submit,
      product_id,
      sample_order_master_id,
      sample_order_date,
      shipping_date,
      delivery_address,
      po_no,
      po_date,
      customer_id,
      sales_person_id,
      remarks,
      status,
      cart,
      buttonText,
      currentStatus,
      ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            "heading", "|", "bold", "italic", "underline", "|", "link",
            "bulletedList", "numberedList", "|", "outdent", "indent",
            "|", "blockQuote", "|", "undo", "redo",
          ],
        },
        language: "en",
      },
    };
  },
  mounted() {
    const user = this.$store.getters.getAuthUser;
    const id = this.$route.query.id;

    this.sample_order_date.value.value = new Date();
    this.shipping_date.value.value = new Date();

    if (user) {
      this.sales_person_id.value.value = user.id;
    }

    if (id) {
      this.isEntryMode = false;
      this.$store.commit("SET_LOADING", { color: "primary" });
      this.$store.dispatch("getSampleOrderById", id)
        .then(saleOrder => {
          this.sample_order_master_id.value.value = saleOrder.id;
          this.sample_order_date.value.value = saleOrder.sample_order_date ? new Date(saleOrder.sample_order_date) : new Date();
          this.shipping_date.value.value = saleOrder.shipping_date ? new Date(saleOrder.shipping_date) : new Date();
          this.delivery_address.value.value = saleOrder.delivery_address;
          this.po_no.value.value = saleOrder.po_no;
          this.po_date.value.value = saleOrder.po_date ? new Date(saleOrder.po_date) : null;
          this.customer_id.value.value = saleOrder.customer_id;
          this.sales_person_id.value.value = saleOrder.sales_person_id;
          this.remarks.value.value = saleOrder.remarks || "";
          this.contactsAddressList = saleOrder.customer?.contacts || [];
          this.cart = (saleOrder.details || []).map(item => ({
            product_id: item.product_id,
            product_name: item.product?.name || "",
            product_code: item.product?.code || "",
            qty: item.quantity,
            unit_id: item.product?.unit_id || "",
            unit_name: item.product?.unit?.name || "",
            lot_no: item.lot_no || "",
            description: item.description || "",
          }));
          this.$store.commit("UNSET_LOADING");
        })
        .catch(() => this.$store.commit("UNSET_LOADING"));
    }
  },
};
</script>

<style>

</style>
